export default function BackgroundFx({ variant = "default" }) {
  return (
    <div
      className="pointer-events-none fixed inset-0 -z-10 overflow-hidden bg-mgfc-bg"
      aria-hidden
    >
      <div className="sun" />
      <div className="sun-bands" />
      <div className="grid-floor" />
      {variant === "default" && (
        <div className="absolute inset-0 dot-grid opacity-50" />
      )}
      {variant === "dense" && (
        <div className="absolute inset-0 dot-grid opacity-80" />
      )}
      <div
        className="absolute inset-x-0 top-0 h-px"
        style={{
          background:
            "linear-gradient(90deg, transparent, #FF00FF 25%, #00FFFF 75%, transparent)",
        }}
      />
    </div>
  );
}
